import React from "react"
import { Columns, Section } from "react-bulma-components"
import SecondaryPage from "./SecondaryPage"

const ContentPage: React.FC = ({ children }) => {
  return (
    <SecondaryPage>
      <div className="small-extra-padding-left">
        <Columns>
          <Columns.Column size={8}>
            <Section>{children}</Section>
          </Columns.Column>
        </Columns>
      </div>
    </SecondaryPage>
  )
}

export default ContentPage
